import React from 'react';
import classnames from 'classnames';
import WavedLoading from '../waved-loading';
import Loading from '../loading';
import ControlDialog from '../control-dialog';
import classes from './info-dialog.scss';
const InfoDialog = ({
  dataPopup = undefined,
  onRequestClose = undefined,
  open = false,
  header = undefined,
  subHeader = '',
  content,
  bodyStyle = undefined,
  bodyClassName = undefined,
  contentStyle = {},
  titleStyle = undefined,
  setInnerHTML = undefined,
  titleClass = undefined,
  className = undefined,
  modal = false,
  showCloseButton = true,
  contentClassName = '',
  rootContentClassName = undefined,
  headerless = false,
  actionsContainerStyle = undefined,
  isLoading = false,
  isCircleLoader = false,
  contentWrapperClassName = undefined,
  hasLoaderBackground = false,
  paperClassName = '',
  titleContentClass = '',
  closeButtonClassName = ''
}) => {
  const titleEl = !headerless ? /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.title, titleClass)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes['title-content'], titleContentClass)
  }, /*#__PURE__*/React.createElement("h4", null, subHeader), /*#__PURE__*/React.createElement("h2", null, header))) : null;
  const contentBody = setInnerHTML ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  }) : /*#__PURE__*/React.createElement("div", null, content);
  const loader = isCircleLoader ? /*#__PURE__*/React.createElement(Loading, null) : /*#__PURE__*/React.createElement(WavedLoading, {
    hasWhiteBackground: hasLoaderBackground
  });
  const contentEl = /*#__PURE__*/React.createElement("div", {
    className: classnames({
      [classes.content]: !contentClassName,
      [contentClassName]: contentClassName
    })
  }, contentBody, isLoading && loader);
  return /*#__PURE__*/React.createElement(ControlDialog, {
    dataPopup: dataPopup,
    title: titleEl,
    paperClassName: paperClassName,
    content: contentEl,
    titleStyle: titleStyle,
    bodyStyle: bodyStyle,
    contentStyle: contentStyle,
    onRequestClose: onRequestClose,
    dialogClass: className,
    open: open,
    modal: modal,
    showCloseButton: showCloseButton,
    contentClassName: rootContentClassName,
    bodyClassName: bodyClassName,
    actionsContainerStyle: actionsContainerStyle,
    contentWrapperClassName: contentWrapperClassName,
    closeButtonClassName: closeButtonClassName
  });
};
export default InfoDialog;